export const canvas = document.getElementById("canvas");
export const ctx = canvas.getContext("2d");

const dog = new Image();
dog.src = 'https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_10,w_100/v1518548399/dog_jv6crw.gif';


export default class Dog {

  constructor() {
    this.width = 75;
    this.height = 75;
    this.dogX = (canvas.width - this.width)/2;
    this.dogY = (canvas.height - this.height - 10);
  }


  drawDog(rightPressed, leftPressed, downPressed, upPressed) {
    // ctx.beginPath();
    // ctx.rect(this.dogX, this.dogY, this.width, this.height);
    ctx.drawImage(dog, this.dogX, this.dogY, this.height, this.width);
    ctx.fillStyle = "#0095DD";
    // ctx.fill();
    // ctx.closePath();
    if (leftPressed === true && this.dogX > 50) {
      this.dogX -= 3;
    }
    if (rightPressed === true && this.dogX < canvas.width - 100) {
      this.dogX += 3;
    }
    if (downPressed === true && this.dogY < canvas.height - 75) {
      this.dogY += 3;
    }
    if (upPressed === true && this.dogY > 30) {
      this.dogY -= 3;
    }
  }
}



// WEBPACK FOOTER //
// ./lib/dog.js